import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";
import IEmployeeData from "adminPanel/employee/models/IEmployee";
import {
  ApprovalType,
  IAllowedApproval,
  IRequestedApproval,
  ISupervisor,
} from "amnPos/ticket/Ticket";

const baseUrl = getApiBaseUrl() + "approvals/";

function CreateSupervisorItemDiscountApproval(
  requestedApproval: IRequestedApproval,
) {
  return axios.post<IAllowedApproval[]>(
    `${baseUrl}create-supervisor-item-discount-approval`,
    { requestedApprovalDto: requestedApproval },
  );
}

function CreateSupervisorExternalTransaction(
  requestedApproval: IRequestedApproval,
) {
  return axios.post<IAllowedApproval[]>(
    `${baseUrl}create-supervisor-external-transaction`,
    {
      requestedApprovalDto: requestedApproval,
    },
  );
}

function CreateSupervisorInstantCompletedApproval(
  requestedApproval: IRequestedApproval,
) {
  return axios.post<IAllowedApproval[]>(
    `${baseUrl}create-supervisor-instant-complete-approval`,
    {
      requestedApprovalDto: requestedApproval,
    },
  );
}

const ApprovalsApi = {
  CreateSupervisorItemDiscountApproval,
  CreateSupervisorExternalTransaction,
  CreateSupervisorInstantCompletedApproval,
};

export default ApprovalsApi;
